import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductLifeCycleStatusService {
    public constructor(private http: HttpClient) {}

    public getStatus(serialnumber: string): Observable<{ productLifeCycleStatus: string }> {
        return this.http.get<{ productLifeCycleStatus: string }>(
            `/api/product/${serialnumber}/life-cycle-status`
        );
    }
}
